<template>
    <div>
        <HeaderDesign :image="image"></HeaderDesign>
        <div style="width: 100%; height: 100vh; margin-bottom: -14em; text-align: left;">
            <h1 class="left__placing header__style" style="padding-top: 5%;">Forgot Password?</h1>
            <div class="content left__placing">
                <div class="input-field-area" style="padding-bottom: 2%;">
                    <div class="span__style">Please enter the new password</div>
                    <input class="input-filed" type="password" placeholder="New Password" v-model="newPassword">
                </div>
                <div class="input-field-area" style="padding-bottom: 2%;">
                    <div class="span__style">Repeat password</div>
                    <input class="input-filed" type="password" placeholder="New Password" v-model="repeatPassword">
                </div>
                <div style="padding-bottom: 2%;">
                    <label class="error" v-if="error !== null">{{error}}</label>
                    <button class="adway-btn-class" @click="changePassword" style="width: 21%;">
                        <clip-loader :loading="loginSpinner" :color="'#fff'"/>
                        <span class="btn__text__bold">Submit</span>
                    </button>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
    </div>
</template>

<script>
import HeaderDesign from '@components/design/HeaderDesign.vue'
import FooterView from '@components/footer/FooterView.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import toast from '@utils/toast.js'
export default {
    name: 'PasswordReset',
    components: {
        HeaderDesign,
        FooterView
    },
    data: function () {
        return {
            image: '',
            newPassword: '',
            repeatPassword: '',
            token: '',
            error: null,
            loginSpinner: false
        }
    },
    comments: {
        ClipLoader
    },
    methods: {
        changePassword () {
            this.loginSpinner = true
            if (this.newPassword === this.repeatPassword && this.newPassword !== '') {
                var url = '/user/password/change'
                var body = {
                    code: this.token,
                    data: {
                        secret: this.newPassword
                    }
                }
                this.request(url, 'POST', body).then((response) => {
                    if (response.code === 0) {
                        toast.successMessage('Password is changed')
                        this.$router.push('/login')
                        this.loginSpinner = false
                    }
                }).catch((error) => {
                    toast.errorMessage(error)
                    this.loginSpinner = false
                })
            } else {
                this.loginSpinner = false
                //alert
                toast.errorMessage('Password conditions are not accepted')
                // if (this.newPassword !== '') {
                //     this.error = 'No password is entered'
                // }
                // if (this.newPassword !== this.repeatPassword) {
                //     this.error = 'Passwords are not equal'
                // }
            }
        }
    },
    created: function () {
        this.token = window.location.search.split("=")[1]
    }
}
</script>

<style scoped>

.header__style {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: bold;
    font-size: 34px;
    line-height: 41px;

    color: #11364E;
}

.span__style {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;

    /* identical to box height */

    color: #191919;
}

.input_fileds {
    display: inherit;
    margin-top: 1%;
    width: 14vw;
    height: 3.2vh;
    border-radius: 6px;
    border: 1px solid #CCD4E0;
    padding-left: 0.5%;
}

.content {
    padding-top: 3%;
}

.left__placing {
    width: 80%;
    padding-left: 3%
}

::-webkit-input-placeholder{
    font-family: "Montserrat";
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;

    color: #777777;
}

.error {
    font-size: 10px;
    color: #DD4242;
    margin-top: 5px;
    margin-bottom: 0;
    padding-bottom: 0;
}

</style>
